// Application Settings Types and Interfaces

export interface ApplicationInfo {
  app_id: string;
  name: string;
  app_status: string;
  is_calls_enabled: boolean;
  is_chats_enabled: boolean;
  is_notifications_enabled: boolean;
  is_scheduled_calls_enabled: boolean;
  is_chat_bot_enabled: boolean;
}

export interface ApplicationThemeSettings {
  primaryColor: string;
  secondaryColor: string;
}

export interface DataPrivacySettings {
  allowDataAccess: boolean;
  accessUserAnalytics: boolean;
  accessChatAnalytics: boolean;
  accessCallAnalytics: boolean;
  accessSentimentAnalysis: boolean;
}

export interface AdvancedSettings {
  profanityFilterEnabled: boolean;
  profanityWords: string[];
  regexPatterns: string[];
}

export interface SecuritySettings {
  allowedDomains: string[];
  allowedIPs: string[];
}

export interface StorageSettings {
  destination_type: 'S3';
  bucket_name: string;
  access_key: string;
  secret_key: string;
  cloud_region: string;
  upload_file_path: string;
}

// Role permissions configuration
export const ROLE_PERMISSIONS = {
  Admin: {
    general: { read: true, write: true },
    theme: { read: true, write: true },
    privacy: { read: true, write: true },
    security: { read: true, write: true },
    storage: { read: true, write: true },
    advanced: { read: true, write: true },
    deleteApplication: true,
    manageApiKeys: true,
    exportData: true,
    viewActivityLogs: true
  },
  Billing: {
    general: { read: true, write: false },
    theme: { read: true, write: true },
    privacy: { read: true, write: false },
    security: { read: false, write: false },
    storage: { read: false, write: false },
    advanced: { read: false, write: false },
    deleteApplication: false,
    manageApiKeys: false,
    exportData: true,
    viewActivityLogs: false
  },
  'Desk Admin': {
    general: { read: true, write: true },
    theme: { read: true, write: true },
    privacy: { read: true, write: false },
    security: { read: true, write: true },
    storage: { read: true, write: true },
    advanced: { read: false, write: false },
    deleteApplication: false,
    manageApiKeys: true,
    exportData: true,
    viewActivityLogs: true
  },
  'Desk Agent': {
    general: { read: true, write: false },
    theme: { read: true, write: false },
    privacy: { read: false, write: false },
    security: { read: false, write: false },
    storage: { read: false, write: false },
    advanced: { read: false, write: false },
    deleteApplication: false,
    manageApiKeys: false,
    exportData: false,
    viewActivityLogs: false
  }
} as const;

export type UserRole = keyof typeof ROLE_PERMISSIONS;

// Permission utility types
export interface PermissionUtils {
  canAccessSection: (section: keyof typeof ROLE_PERMISSIONS['Admin']) => boolean;
  canEditSection: (section: keyof typeof ROLE_PERMISSIONS['Admin']) => boolean;
  canPerformAction: (action: keyof typeof ROLE_PERMISSIONS['Admin']) => boolean;
}

export interface TabItem {
  id: string;
  label: string;
  icon: React.ReactElement;
  permission: string;
}